import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Product from '@models/product';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DropdownWrapper } from './styles';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  products: Array<Product>;
  sku: string | '';
  updateSelectedProducts: (sku: string, index: number) => void;
  index: number;
  selectedSkus: (string | '')[];
  asContentRow?: boolean;
  className?: string;
}

export const Dropdown = ({
  sku,
  products,
  updateSelectedProducts,
  index,
  selectedSkus,
  className,
}: Props) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  return (
    <DropdownWrapper className={classNames('xl:tw-min-w-[370px] md:tw-pb-0', className)}>
      <FormControl fullWidth>
        <Select
          value={sku}
          label="product"
          onChange={(event: SelectChangeEvent<string>) => {
            updateSelectedProducts(event.target.value, index);
          }}
          displayEmpty
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          renderValue={(selected) =>
            sku
              ? products.find(({ sku: productSku }: { sku: string }) => selected === productSku)
                  ?.title
              : t('productComparisonContent.chooseGrillLabel', undefined, {
                  default: 'Choose Grill',
                })
          }
          IconComponent={() => (
            <button onClick={() => setOpen((curr) => !curr)} aria-label="Select a grill to compare">
              <ExpandMoreIcon className="tw-pointer-events-none" />
            </button>
          )}
          open={open}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: '0',
                marginTop: '-46px',
                marginLeft: {
                  md: '19px',
                },
              },
            },
          }}
        >
          {products
            .filter((product) => sku === product.sku || !selectedSkus.includes(product.sku))
            .reduce(
              (acc: Product[], product) =>
                product.sku === sku ? [product, ...acc] : [...acc, product],
              [],
            )
            .map((product) => {
              return (
                <MenuItem key={product.sku} value={product.sku}>
                  {product.title}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </DropdownWrapper>
  );
};

export default Dropdown;
